<template>
  <div class="institute-smale">
    <div class="institute-smale-title">斯梅尔研究院</div>
    <div class="institute-smale-content">
      <p>
        华院计算2016年发起设立的斯梅尔数学与计算研究院（以下简称“斯梅尔研究院”），世界著名数学家、美国科学院院士史蒂芬·斯梅尔(StephenSmale)受邀担任名誉主席，面向全球进行数学和计算理论研究。斯梅尔研究院致力于使用大数据和算法理论，为基础科学和其它科学研究提供支持，以构建更好的研究方法。
      </p>
      <div class="institute-smale-content-leader">
        <img :src="ecological_institute_smale" alt="Stephen Smale" />
        <div class="institute-smale-content-leader-bg">
          <div class="institute-smale-content-leader-position">名誉主席</div>
          <div class="institute-smale-content-leader-name">
            史蒂芬·斯梅尔<br />
            Stephen Smale
          </div>
        </div>
      </div>
      <ul class="institute-smale-honour-list">
        <li class="institute-smale-honour-item" v-for="(item, index) in honour"
          :key="`about-team-honour-item${index + 1}`">
          <strong>·</strong>{{ item }}
        </li>
      </ul>
      <p>
        我们的核心算法体系由斯梅尔数学与计算研究院与公司自研算法实验室共同驱动，持续产出原创算法成果。学术研究及交流平台斯梅尔数学与计算研究院由我们于 2016
        年发起成立，汇聚多位菲尔兹奖、沃尔夫奖、图灵奖得主及国内外科学院院士等全球顶尖智力，并联合加州大学伯克利分校、密歇根大学、复旦大学、上海交通大学及浙江大学等知名学府的教授，在计算基础理论、认知科学理论、计算生物学、非线性期望等领域开展深度研究，为公司持续注入理论创新动力。
      </p>
    </div>
    <van-button type="info" @click="goPath">了解更多</van-button>
  </div>
</template>
<script>
import ecological_institute_smale from "@/../static/img/ecological/ecological_institute_smale.png";
export default {
  data() {
    return {
      ecological_institute_smale,
      honour: [
        "菲尔兹奖得主",
        "沃尔夫数学奖得主",
        "美国国家科学奖章得主",
        "奥斯瓦尔德·维布伦几何学奖获得者"
      ]
    };
  },
  methods: {
    goPath() {
      window.open("http://www.smaleinstitute.com/");
    }
  }
};
</script>
<style lang="less" scoped>
.institute-smale {
  padding: 44px 64px 96px;
  text-align: center;
  background: #f8f9fb;

  .institute-smale-title {
    font-size: 40px;
    color: #08204d;
    line-height: 56px;
  }

  .institute-smale-content {
    margin-top: 40px;
    font-size: 24px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #08204d;
    line-height: 40px;
    text-align: left;

    .institute-smale-content-leader {
      height: 398px;
      display: flex;
      justify-content: center;

      >img {
        width: 264px;
        height: 398px;
      }

      .institute-smale-content-leader-bg {
        flex: 1;
        padding: 36px 40px;
        background: url("../../../../static/img/about/about_team_bg.png") no-repeat 0 0 / 100%;

        .institute-smale-content-leader-position {
          font-size: 26px;
          color: #08204d;
          line-height: 36px;
        }

        .institute-smale-content-leader-name {
          margin-top: 8px;
          display: flex;
          flex-direction: columns;
          font-size: 32px;
          color: #08204d;
          line-height: 44px;
        }
      }
    }

    .institute-smale-honour-list {
      margin-top: 32px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }

  .van-button {
    margin-top: 64px;
    width: 304px;
    height: 96px;
    margin: 0 auto;
    font-size: 32px;
    color: #ffffff;
    background: #4256f1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ecological/institute/smale.vue